import { useEffect, useRef, useState } from 'react';
interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
/** No disruptive install popup; expose installation only when the browser offers it. */
export function InstallApp(): JSX.Element | null {
  const prompt = useRef<InstallPrompt | null>(null);
  const [available, setAvailable] = useState(false);
  const [ios, setIos] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    setIos(
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
    );
    const offer = (event: Event) => {
      event.preventDefault();
      prompt.current = event as InstallPrompt;
      setAvailable(true);
    };
    const installed = () => {
      prompt.current = null;
      setAvailable(false);
      setIos(false);
    };
    window.addEventListener('beforeinstallprompt', offer);
    window.addEventListener('appinstalled', installed);
    return () => {
      window.removeEventListener('beforeinstallprompt', offer);
      window.removeEventListener('appinstalled', installed);
    };
  }, []);
  if (available)
    return (
      <button
        className="min-h-11 text-white hover:underline"
        onClick={async () => {
          const current = prompt.current;
          if (!current) return;
          prompt.current = null;
          setAvailable(false);
          try {
            await current.prompt();
            await current.userChoice;
          } catch {
            /* Browser may withdraw the offer. */
          }
        }}
      >
        Install SkyTech app
      </button>
    );
  if (ios)
    return (
      <details className="max-w-xs text-white/80">
        <summary className="min-h-11 cursor-pointer py-3">Install SkyTech app</summary>
        <p>In Safari, open Share, choose Add to Home Screen, then Add.</p>
      </details>
    );
  return null;
}
